module.exports = __webpack_public_path__ + "img/pocket welt width.ae8e0ccd.png";